import { ModelManager } from './ModelManager';
import { TextureManager } from './TextureManager';
import { MaterialManager } from './MaterialManager';
import { AudioManager } from './AudioManager';

/**
 * Facade over the four asset sub-systems. One implementation today, but
 * already split into independent classes with no cross-dependencies
 * (Model/Texture/Material/Audio each stand alone) — promoting any of them
 * to its own module/service later is a matter of importing them directly
 * instead of via this facade, not a rewrite.
 */
export class AssetManager {
  readonly models: ModelManager;
  readonly textures: TextureManager;
  readonly materials: MaterialManager;
  readonly audio: AudioManager;

  constructor() {
    this.models = new ModelManager();
    this.textures = new TextureManager();
    this.materials = new MaterialManager();
    this.audio = new AudioManager();
  }
}
